import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { CommonService } from 'src-adisco/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private cachedUser: any = null;
  private cachedMemberInfo: any = null;

  constructor(private _commonService: CommonService, private httpClient:HttpClient) {}

  // Method to get user profile, using cache if available
  getUserProfile(userId: string): Observable<any> {
    if (this.cachedUser) {
      return of(this.cachedUser);
    } else {
      return this._commonService.getUser(userId).pipe(
        tap(user => this.cachedUser = user) // Cache the user data
      );
    }
  }

  // Method to get member info, using cache if available
  getMemberInfo(linkToLegalEntityId: string): Observable<any> {
    if (this.cachedMemberInfo) {
      return of(this.cachedMemberInfo);
    } else {
      return this._commonService.getInfoMember(linkToLegalEntityId).pipe(
        tap(memberInfo => this.cachedMemberInfo = memberInfo) // Cache the member info
      );
    }
  }

  // Clear the cache (optional, if you need to reset)
  clearCache(): void {
    this.cachedUser = null;
    this.cachedMemberInfo = null;
  }

  getCivilities(value:string){
    const filter = [
      {
          champ: 'nomTable',
          conditions: [
              {
                  condition: 'CONTAINS',
                  valeur: value,
              },
          ],
      },
    ]
    return this.httpClient
            .post<any[]>(
                `/view/filtres-and-sorts/parametre/${0}/${100}/fr_FR`,
                { filters: filter}
            )
  }
}
